import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa en liderazgo o psicología?',
  a: 'No. Proyecto Elite está diseñado para profesionales en cualquier etapa de carrera. El contenido parte desde los fundamentos y escala hasta técnicas de élite. Si podés leer esta página, podés aplicar el sistema desde hoy.'
}, {
  q: '¿Cuánto tiempo necesito para ver resultados?',
  a: 'Desde el primer tomo ya podés aplicar cambios concretos en tu próxima reunión o entrevista. Los resultados más significativos (cambios en cómo te perciben, respuestas diferentes de tu entorno) generalmente se notan en las primeras 2 a 3 semanas de práctica consistente.'
}, {
  q: '¿Esto funciona si trabajo en relación de dependencia y en empresa grande?',
  a: 'Sí. El sistema fue desarrollado específicamente para entornos corporativos con jerarquías reales, política interna y evaluaciones de desempeño. Cada tomo incluye ejemplos y protocolos aplicados a situaciones de empresa: reuniones con el C-Level, negociaciones salariales, presentaciones a directorios y manejo de críticos internos.'
}, {
  q: '¿Cómo recibo los materiales?',
  a: 'Al instante. Apenas se confirma el pago recibís un email con el link de descarga de todos los PDFs. No necesitás instalar nada. Compatible con celular, tablet y PC desde el primer segundo.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si aplicás el sistema y no notás ninguna diferencia, escribinos y te devolvemos el 100% sin preguntas. No existe riesgo para vos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-brand-black pb-32" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-116">
            Preguntas Frecuentes
          </h2>
          <p className="text-brand-muted text-lg" data-id="element-117">
            Todo lo que necesitás saber antes de decidir
          </p>
        </div>

        <div className="space-y-4" data-id="element-118">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border border-brand-gold/30 rounded-lg bg-brand-dark overflow-hidden" data-id="element-119">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-120">
                  <div className="flex items-center pr-4" data-id="element-121">
                    <HelpCircle className="text-brand-gold mr-4 flex-shrink-0" size={24} data-id="element-122" />
                    <span className="text-brand-text font-bold text-lg" data-id="element-123">
                      {faq.q}
                    </span>
                  </div>
                  <ChevronDown className={`text-brand-gold transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-124" />
                </button>

                {isOpen && <div className="px-6 pb-5 pt-0 text-brand-muted leading-relaxed ml-10 animate-fade-in" data-id="element-125">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}